import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

import { ref, reactive } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import type { FormInstance } from "element-plus";
import { ZoomTimeZone } from "@/core/types/ZoomTimeZone";
import ToolServices from "../services/ToolServices";
import axios from "axios";

export default /*#__PURE__*/_defineComponent({
  __name: 'CreateMeeting',
  setup(__props, { expose: __expose }) {

const isLoading = ref(true);
const modalRef = ref<InstanceType<typeof SimpleForm>>();

const ruleFormRef = ref<FormInstance>();
const rules = reactive<any>({});

const formData = ref<any>({
  audio: "both",
  meeting_authentication: false,
  join_before_host: true,
  host_video: false,
  participant_video: false,
  mute_upon_entry: true,
  waiting_room: false,
  timezone: "Australia/Sydney",
  auto_recording: "cloud",
  type: 2,
});

const autoRecordingOptions = [
  { label: "Local", value: "local" },
  { label: "Cloud", value: "cloud" },
  { label: "None", value: "none" },
];

const createMeeting = async () => {
  isLoading.value = true;

  isLoading.value = false;
};

const show = async () => {
  isLoading.value = true;
  modalRef.value?.show();
  isLoading.value = false;
};

const hide = () => {
  modalRef.value?.hide();
};
const submit = async () => {
  isLoading.value = true;
  await createMeeting();
  isLoading.value = false;
};
__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: "Create Zoom Meeting",
    "is-loading": isLoading.value,
    submit: submit,
    style: {"width":"500px"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: formData.value,
          rules: rules,
          class: "demo-ruleForm",
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "Topic" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.topic,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.topic) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Start Time" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: formData.value.start_time,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.start_time) = $event)),
                  type: "datetime",
                  placeholder: "Select date and time"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "TimeZone" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formData.value.timezone,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.timezone) = $event)),
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ZoomTimeZone), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item,
                        label: item,
                        value: item
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Recording" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formData.value.auto_recording,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.auto_recording) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(autoRecordingOptions, (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ]),
    _: 1
  }, 8, ["is-loading"]))
}
}

})